class Position {
  constructor(params) {
    this.setInitPosition(params);
  }

  isValidPosition(val) {
    if (!_.isPlainObject(val)) return false;

    if (_.isNil(val.x) || _.isNil(val.y)) return false;

    return true;
  }

  setInitPosition(val) {
    const isValid = this.isValidPosition(val);

    if (!isValid) {
      throw Error('Not a valid position.');
    }

    this.x = val.x;
    this.y = val.y;
  }
}

export default Position;



// WEBPACK FOOTER //
// ./src/models/Common/Positon.js